import styled from "styled-components";

import { ForecastingChangeRecords } from "./ForecastingChangeRecords";
import { ForecastWellStatus } from "./models/forecastWell";

function ForecastingEditorChangeRecords({
  forecastId,
  status,
  declineType
}: {
  forecastId: string;
  status: ForecastWellStatus;
  declineType: string;
}) {
  return (
    <ForecastingEditorChangeRecordsWrapper>
      <ForecastingChangeRecords
        forecastId={forecastId}
        status={status}
        declineType={declineType}
      />
    </ForecastingEditorChangeRecordsWrapper>
  );
}

export default ForecastingEditorChangeRecords;

const ForecastingEditorChangeRecordsWrapper = styled.div`
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 0 0 20px 20px;
  background: white;
`;
